module.exports = __webpack_public_path__ + "img/1537868827.6617bd21.jpg";